import { render, staticRenderFns } from "./VehicleVisualSummary.vue?vue&type=template&id=2f5642c0"
import script from "./VehicleVisualSummary.vue?vue&type=script&lang=js"
export * from "./VehicleVisualSummary.vue?vue&type=script&lang=js"
import style0 from "./scss/vehicle-visual-summary.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/booking-staging.greenmotion.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f5642c0')) {
      api.createRecord('2f5642c0', component.options)
    } else {
      api.reload('2f5642c0', component.options)
    }
    module.hot.accept("./VehicleVisualSummary.vue?vue&type=template&id=2f5642c0", function () {
      api.rerender('2f5642c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/scripts/greenmotion-shared/Components/quotes/VehicleVisualSummary.vue"
export default component.exports